import {
	type AssetTypeEnum,
	type Duration,
	type PatternSpecificationEnum,
	type PositionEnum,
	type Setup,
	type StageEnum,
	assetList,
	directionList,
	durationList,
	patternSpecificationList,
	stageList,
} from '@here/api'
import { debounce } from '@solid-primitives/scheduled'
import { createSignal } from 'solid-js'

export type RequestSource = 'default' | 'taken' | 'subscribed'
export type Sort = 'recent-activity' // recently update // or commented?
| 'recently-submitted'
| 'subscribers' // most subscribed
| 'takers' // most takern
| 'PHQ' // PHQ high o low
| 'community-score'

export type SetupFilter = {
	// order: Partial<Record<keyof Setup | 'taken', boolean>>
	// source: RequestSource
	sort: Sort
	assetType: AssetTypeEnum[]
	stage: StageEnum[]
	position: PositionEnum[]
	duration: Duration[]
	symbols: string[]
	patternSpecification: PatternSpecificationEnum[]
}

export const defaults: SetupFilter = {
	// order: {
	// 	updated_at: true,
	// 	created_at: undefined,
	// 	risk_reward_ratio: undefined,
	// 	taken: undefined,
	// },
	// source: 'default',
  sort: 'recent-activity',
	symbols: [],
	duration: durationList,
	stage: stageList,
	position: directionList,
	patternSpecification: patternSpecificationList,
	assetType: assetList,
}

export function useFilters() {
	const [filters, setFilters] = createSignal<SetupFilter>(defaults)
	const [fetchFilters, setFetchFilters] = createSignal<SetupFilter>(defaults)
	const [page, setPage] = createSignal(1)
	const debouncedSetFilters = debounce((newFilters: SetupFilter) => {
		setFilters(newFilters)
		setPage(1) // Reset page to 1 when filters change
	}, 300) // Debounce delay of 300ms

	const runFilters = () => {
		setFetchFilters(filters())
	}

	// const setOrder = (filter: Partial<keyof Setup>) => {
	// 	debouncedSetFilters({
	// 		...filters(),
	// 		order: {
	// 			...filters().order,
	// 			[filter]:
	// 				filters().order[filter] === true
	// 					? false
	// 					: filters().order[filter] === false
	// 						? undefined
	// 						: true,
	// 		},
	// 	})
	// }

	// const setSource = (source: RequestSource) => {
	// 	debouncedSetFilters({
	// 		...filters(),
	// 		source,
	// 	})
	// }

  const setSort = (sort: Sort) => {
		debouncedSetFilters({
			...filters(),
			sort,
		})
	}

	const setSymbols = (symbols: string[]) =>
		debouncedSetFilters({
			...filters(),
			symbols,
		})

	const setAssetType = (assetType: AssetTypeEnum[]) =>
		debouncedSetFilters({
			...filters(),
			assetType,
		})

	const setDuration = (duration: Duration[]) =>
		debouncedSetFilters({
			...filters(),
			duration,
		})

	const setPosition = (position: PositionEnum[]) =>
		debouncedSetFilters({
			...filters(),
			position,
		})

	const setStage = (stage: StageEnum[]) =>
		debouncedSetFilters({
			...filters(),
			stage,
		})

	const setPatternSpecification = (patternSpecification: PatternSpecificationEnum[]) =>
		debouncedSetFilters({
			...filters(),
			patternSpecification,
		})

	const resetFilters = () => {
		setFilters(defaults)
	}
	const areFiltersSet = () => JSON.stringify(filters()) === JSON.stringify(defaults)

	return {
		// setSource,
		setDuration,
		fetchFilters,
		runFilters,
		setSymbols,
		areFiltersSet,
		debouncedSetFilters,
		filters,
		page,
		setPatternSpecification,
		resetFilters,
		setAssetType,
		setFilters,
		// setOrder,
    setSort,
		setPage,
		setPosition,
		setStage,
	}
}
